var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"appear":""},on:{"before-appear":_vm.beforeAppear,"appear":_vm.enter,"enter":_vm.enter,"leave":_vm.leave}},[_c('h3',{key:_vm.chapter,staticClass:"chapter"},[_vm._v(" "+_vm._s('chapter ' + _vm.chapter)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }